<template>
  <div style="background-color: #fff">
    <Header :title="$t('autograph.title')" />
    <div
      class="full-page-box"
      style="margin: 10px; text-align: center; background-color: #fff"
    >
      <p>{{ $t("autograph.msg") }}</p>
      <br />
      <canvas
        ref="signaturePad"
        width="350"
        height="460"
        style="border: 1px solid rgb(4 109 181); border-radius: 8px"
      ></canvas>
      <button @click="clearSignature" class="btn">
        {{ $t("autograph.btn1") }}
      </button>
      <button @click="saveSignature" class="btn">
        {{ $t("autograph.btn2") }}
      </button>
      <img
        :src="signatureDataUrl"
        alt="签名图片"
        v-if="signatureDataUrl && false"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
import SignaturePad from "signature_pad";
import { Toast } from "vant";
export default {
  name: "AutographView",
  components: { Header },
  data() {
    return {
      signaturePad: null,
      signatureDataUrl: null,
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    const canvas = document.querySelector("canvas");
    this.signaturePad = new SignaturePad(canvas);
    this.getInfo()
  },
  methods: {
    clearSignature() {
      this.signaturePad.clear();
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data && res.data.signature && res.data.signature.length > 0) {
            const canvas = this.$refs.signaturePad;
            const ctx = canvas.getContext('2d');

            // 创建Image对象并设置src
            const image = new Image();
            image.src = res.data.signature; // 替换为你的图片路径

            // 图片加载完成后绘制到canvas上
            image.onload = function() {
                ctx.drawImage(image, 0, 0); // 在(0,0)位置绘制图片
            };
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    saveSignature() {
      if (!this.signaturePad.isEmpty()) {
        this.signatureDataUrl = this.signaturePad.toDataURL();

        this.$http({
          method: "post",
          data: {
            signature: this.signatureDataUrl
          },
          url: "setsign",
        }).then((res) => {
          if (res.code == 200) {
            console.log(res)
            Toast(res.msg);
            
          } else{
            Toast(res.msg);
          }
        });
      } else {
        Toast(this.$t("autograph.null"));
      }
    },
  },
};
</script>
<style scoped>
.btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181);
  color: #fff;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: 10px;
}
</style>
